import styled from 'styled-components';
import Select from 'react-select';

export const FilterSelect = styled(Select)`
  width: 100%;
  height: 3.125rem;
  margin: 0.625rem 0;
  outline: none;

  /* @media (min-width: 992px) {
    ${({ isArabic }) => (isArabic ? 'margin-left: 1.5rem;' : 'margin-right: 1.5rem;')}
  } */
  @media (min-width: 1200px) {
    max-width: 18.625rem;
  }

  .dropdown__control {
    width: 100%;
    height: 3.125rem;
    box-shadow: none;
    outline: none;
    text-align: left;
    line-height: 1.5;
    text-align: ${({ isArabic }) => (isArabic ? 'right' : 'left')};
    font-family: ${({ isArabic }) => (isArabic ? 'GESSTwoDWTCMedium' : 'DINRegular')};
    font-size: ${({ isArabic }) => (isArabic ? '10px' : '0.875rem')};
    caret-color: transparent;
    padding: 0 1rem;
    border: 1px solid ${({ isOpen }) => (isOpen ? '#dae0e5' : 'transparent')};
    cursor: pointer;
    background-color: #fff;
    &:hover {
      border: 1px solid #dae0e5;
    }

    &:after {
      content: '';
      margin-left: ${({ isArabic }) => (isArabic ? '0' : '1rem')};
      margin-right: ${({ isArabic }) => (isArabic ? '1rem' : '0')};
      display: inline-block;
      margin-bottom: 3px;
      width: 0;
      height: 0;
      border: solid #000;
      border-width: 0 2px 2px 0;
      padding: 3px;
      animation-name: ${({ isOpen }) => (isOpen ? 'arrow-up' : 'arrow-down')};
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
    }

    @keyframes arrow-up {
      from {
        transform: rotate(-315deg);
      }
      to {
        transform: rotate(-135deg);
      }
    }

    @keyframes arrow-down {
      from {
        transform: rotate(-135deg);
      }
      to {
        transform: rotate(45deg);
      }
    }
  }
  .dropdown__indicator-separator,
  .dropdown__indicator {
    display: none;
  }
  .dropdown__menu {
    width: 100%;
    height: auto;
    box-shadow: none;
    border: 1px solid #dae0e5;
    position: absolute;
    top: 3.25rem;
    margin: 0;
    background-color: #fff;
    ${({ isOpen }) =>
      isOpen
        ? `
      animation-name: fade-in;
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `
        : `
      animation-name: fade-out;
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `}
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fade-out {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .dropdown__menu-list {
    padding: 0;
    width: 100%;
    height: 100%;
    max-height: 20rem;
  }
  .dropdown__option {
    width: 100%;
    height: 1.75rem;
    margin: 0.75rem auto;
    font-size: ${({ isArabic }) => (isArabic ? '0.75rem' : '0.875rem')};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #212529;
    background-color: #fff;
    padding: 0 1.25rem;
    cursor: pointer;
    &:active,
    &:focus {
      background-color: #fff;
    }
    &:hover {
      background-color: #f8f9fa;
      color: #1b7bdd;
    }
  }
  .dropdown__option--is-selected {
    color: #fff !important;
    background-color: #1b7bdd !important;
  }

  .dropdown__single-value,
  .dropdown__placeholder {
    color: ${({ isOpen }) => (!isOpen ? '#898989' : '#898989')} !important;
  }
  .dropdown__value-container {
    padding: 0;
  }
`;

export const Wrapper = styled.div`
  align-items: center;
  background-color: #fff;
  border: none;
  flex-flow: row nowrap;
  height: 3.125rem;
  justify-content: center;
  margin: 0.6rem 0;
  outline: none;
  position: relative;
  width: 100%;
  display: flex;

  @media (min-width: 62rem) {
    display: flex;
    margin: 0 0.5rem;
  }
`;

export const Select2 = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  display: flex;
  flex-flow: row nowrap;
  height: 100%;
  justify-content: space-between;
  outline: none;
  padding: 0 1.5rem;
  width: 100%;

  &:hover {
    cursor: pointer;
  }
`;

export const Label = styled.span`
  font-family: 'DINRegular';
  color: #495057;
  font-size: 0.65rem;
  letter-spacing: 0.07rem;
  text-transform: uppercase;
`;

export const Arrow = styled.div`
  margin: 0 0.5rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: auto;

  svg {
    height: 2rem;
    width: 20px;
  }

  &[dir='ltr'] {
    right: 0.5rem;
  }

  &[dir='rtl'] {
    left: 0.5rem;
  }
`;

export const Container = styled.div`
  align-items: flex-start;
  background-color: #fff;
  border-radius: 0.25rem;
  border: 1px solid #b5d4f5;
  flex-flow: column nowrap;
  justify-content: flex-start;
  left: 0;
  max-height: 16rem;
  overflow-y: auto;
  padding: 0.6rem 0;
  position: absolute;
  top: 0;
  transform: translate(-3px, -105%);
  width: auto;
  z-index: 99;
  display: ${({ toggle, displayMenu }) => (toggle && displayMenu ? 'flex' : 'none')};

  &.latestnews_option {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;

    @media (min-width: 62rem) {
      transform: translate(0px, 20%);
      z-index: 9;
    }
  }

  @media (min-width: 62rem) {
    display: ${({ toggle }) => (toggle ? 'flex' : 'none')};
    width: 100%;
  }
`;

export const Option = styled.span`
  width: 100%;
  font-size: 0.8rem;
  font-family: inherit;
  margin: 0.5rem 0;
  padding: 0.3rem 1.5rem;
  text-transform: capitalize;
  transition: all 700ms;

  ${({ selected }) => (selected ? 'background-color: #1b7bdd; color: #fff' : 'color: #212529')};

  &:hover {
    background-color: #f2f2f2;
    color: #1b7bdd;
    cursor: pointer;
  }
`;
